import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import RaisedButton from 'material-ui/RaisedButton';
import thePearl from './img/the_pearl.jpg';
import arrow from './img/arrow.png';
import cookie from 'react-cookie';
import Header from './Header';
import Menu from './Menu';
import MobileMenu from './MobileMenu';
import Scroll from 'react-scroll';
import MediaQuery from 'react-responsive';
import Places from './Places';
import './Home.css';

// Images
import argonaut from './img/stay/argonaut.jpg';
import fairmont from './img/stay/fairmont.jpg';
import kabuki from './img/stay/kabuki.jpg';
import zelos from './img/stay/zelos.jpg';

import calacademy from './img/do/calacademy.jpg';
import dolores from './img/do/dolores.jpg';
import ferry from './img/do/ferry.jpg';
import ggb from './img/do/ggb.jpg';
import ggp from './img/do/ggp.jpg';
import lombard from './img/do/lombard.jpg';
import palace from './img/do/palace.jpg';
import sutro from './img/do/sutro.jpg';

import arizmendi from './img/eat/arizmendi.jpg';
import cancun from './img/eat/cancun.jpg';
import foreigncinema from './img/eat/foreigncinema.jpg';
import liholiho from './img/eat/liholiho.jpg';
import nopa from './img/eat/nopa.jpg';
import outerlands from './img/eat/outerlands.jpg';

var Element = Scroll.Element;

class Home extends Component {
  constructor(props) {
    super();
    this.state = {loggedIn: !!cookie.load('id')};
  };

  render() {
    var venueStyle = {
      backgroundImage: 'url(' + thePearl + ')',
      backgroundPosition: 'top center',
      backgroundSize: 'cover'
    };

    const hotels = [{
      name: "Hotel Kabuki",
      neighborhood: "Tenderloin",
      image: kabuki,
      link: "http://www.jdvhotels.com/hotels/california/san-francisco-hotels/hotel-kabuki/"
    },
    {
      name: "Hotel Argonaut",
      neighborhood: "Fisherman's Wharf",
      image: argonaut,
      link: "http://www.argonauthotel.com/"
    },
    {
      name: "The Fairmont Hotel",
      neighborhood: "Nob Hill",
      image: fairmont,
      link: "http://www.fairmont.com/san-francisco/"
    },
    {
      name: "Hotel Zelos",
      neighborhood: "SOMA",
      image: zelos,
      link: "http://www.viceroyhotelsandresorts.com/en/zelos"
    },
    ];

    const attractions = [{
      name: "Golden Gate Park",
      neighborhood: "",
      image: ggp,
      link: "https://goldengatepark.com/"
    },
    {
      name: "Mission Dolores Park",
      neighborhood: "Mission",
      image: dolores,
      link: "http://sfrecpark.org/destination/mission-dolores-park/"
    },
    {
      name: "Sutro Baths",
      neighborhood: "Outer Richmond",
      image: sutro,
      link: "https://en.wikipedia.org/wiki/Sutro_Baths"
    },
    {
      name: "Ferry Building",
      neighborhood: "Embarcadero",
      image: ferry,
      link: "http://www.ferrybuildingmarketplace.com/"
    },
    {
      name: "Golden Gate Bridge",
      neighborhood: "Presidio",
      image: ggb,
      link: "http://goldengatebridge.org/"
    },
    {
      name: "Lombard Street",
      neighborhood: "Telegraph Hill",
      image: lombard,
      link: "https://en.wikipedia.org/wiki/Lombard_Street_(San_Francisco)"
    },
    {
      name: "California Academy of Sciences",
      neighborhood: "Golden Gate Park",
      image: calacademy,
      link: "http://www.calacademy.org/"
    },
    {
      name: "Palace of Fine Arts",
      neighborhood: "Presidio",
      image: palace,
      link: "https://palaceoffinearts.org/"
    },
    ];

    const restaurants = [{
      name: "Liho Liho Yacht Club",
      neighborhood: "Tenderloin",
      image: liholiho,
      link: "http://liholihoyachtclub.com/"
    },
    {
      name: "Foreign Cinema",
      neighborhood: "Mission",
      image: foreigncinema,
      link: "http://www.foreigncinema.com/"
    },
    {
      name: "Arzimendi",
      neighborhood: "Mission and Inner Sunset",
      image: arizmendi,
      link: "https://www.arizmendibakery.com/"
    },
    {
      name: "Tacqueria Cancun",
      neighborhood: "Mission",
      image: cancun,
      link: "https://www.arizmendibakery.com/"
    },
    {
      name: "NOPA",
      neighborhood: "NOPA",
      image: nopa,
      link: "http://nopasf.com/"
    },
    {
      name: "Outerlands",
      neighborhood: "Outer Sunset",
      image: outerlands,
      link: "http://outerlandssf.com/"
    },
    ];

    var caption = "We got hitched, and here was the sitch.";
    return (
      <div>
        <MediaQuery query="(max-device-width: 800px)">
          <MobileMenu loggedIn={this.state.loggedIn}/>
        </MediaQuery>
        <MediaQuery query="(min-device-width: 800px)">
          <Menu name="top" loggedIn={this.state.loggedIn}/>
        </MediaQuery>
        <Header caption={caption}/>
        <MediaQuery query="(min-device-width: 800px)">
          <Menu name="bottom" loggedIn={this.state.loggedIn}/>
        </MediaQuery>
        <Element name="when" className="section no-background row middle-xs center-xs">
          <div className="col-lg-6 col-xs-10">
            <h2>When</h2>
            <img src={arrow} alt="Alex and Hana" className="arrow"/>
            <div id="datetime"><span id="date">Sunday, May 28, 2017</span> at <span id="time">4:30PM</span></div>
          </div>
        </Element>
        <Element name="venue" className="section background row venue middle-xs center-xs" style={venueStyle}>
          <div className="col-lg-6 col-xs-10">
            <h2>Venue</h2>
            <img src={arrow} alt="Alex and Hana" className="arrow arrow-left"/>
            <h3><a href="http://thepearlsf.com/">The Pearl</a></h3>
            <div>Dogpatch, San Francisco</div>
            <div>601 19th St (at 3rd St)</div>
            <MuiThemeProvider>
              <RaisedButton className="raised-button" label="View Map" target="_" href="https://www.google.com/maps/place/The+Pearl/@37.761046,-122.389015,17z/data=!4m5!3m4!1s0x0:0x6edec8c26638c7ae!8m2!3d37.7614446!4d-122.3889506"/>
            </MuiThemeProvider>
          </div>
        </Element>
        <Element name="story" className="section no-background story row middle-xs center-xs">
          <div className="col-lg-6 col-xs-10">
            <h2>Our Story</h2>
            <img src={arrow} alt="Alex and Hana" className="arrow arrow-left"/>
            <h3>💗</h3>
            <p>Alex and Hana met in San Francisco, through friends, and became best friends, roomies, and soon, life partners.</p>
            <h3>🎤 </h3>
            <p>On the first night they met, they sang karaoke together. Their hearts continue singing a duet every day.</p>
            <h3>💍</h3>
            <p>Alex proposed on the night of their third together-iversary, after what can only be described as a "stirring" performance at Encore Karaoke Lounge.</p>
            <h3>🤗</h3>
            <p>Alex and Hana&#39;s love is made of empathy, respect, passion, and snugs.</p>
          </div>
        </Element>
        <Element name="registry" className="section registry no-background row middle-xs center-xs">
          <div className="col-lg-6 col-xs-10">
            <h2>Registry</h2>
            <p>We are so happy that you’ll be able to join us for our wedding. As many of you know, we live together, and our house is already filled with all the things we could ever need to make it a home. While the presence of your company is the only gift we could ever ask for, an alternative registry has been set up here for those who have expressed an interest in offering a gift to mark the occasion. We are hoping to raise $5,000 for organizations supporting issues that are under threat in the new presidency.</p>
            <MuiThemeProvider>
              <RaisedButton className="raised-button" label="JustGive.org" target="_" href="https://www.justgive.org/alexandhana"/>
            </MuiThemeProvider>
          </div>
        </Element>
        <Element name="where-to-stay" className="section where-to-stay no-background row middle-xs center-xs">
          <div className="col-lg-6 col-xs-10">
            <h2>Where to Stay</h2>
            <p>We want guests to chose the option that works best for them. If you have questions, let us know and we&#39;ll work with you to figure it out!</p>
            <p>We suggest looking at <a target="_" href="https://www.airbnb.com/s/San-Francisco--CA--United-States?page=1&allow_override%5B%5D=&checkin=05%2F28%2F2017&checkout=05%2F29%2F2017&place_id=ChIJIQBpAG2ahYAR_6128GcTUEo&s_tag=x5yKU_V1">AirBNB</a> and finding something that fits your style. The neighborhoods we love include: The Mission, The Castro, The Haight, NOPA, and our own neighborhood, the Inner Sunset.</p>
            <p>You can also rent a hotel room. Here are some we recommend:</p>
            <Places places={hotels} />
          </div>
        </Element>
        <Element name="what-to-do" className="section what-to-do no-background row middle-xs center-xs">
          <div className="col-lg-6 col-xs-10">
            <h2>What to Do</h2>
            <p>Many of our guests are traveling to celebrate with us. We encourage you to visit some of the places in SF that we love while you&#39;re here.</p>
            <div>
              <h3>Attractions</h3>
              <Places places={attractions} />
            </div>
            <div>
              <h3>Restaurants</h3>
              <Places places={restaurants} />
            </div>
          </div>
        </Element>
        <Element name="wedding-day-faqs" className="section wedding-day-faqs no-background row middle-xs center-xs">
          <div className="col-lg-6 col-xs-10">
            <h2>Wedding Day FAQs</h2>
            <p className="question">🤔 Can I bring my kids?</p>
            <p className="answer">In order to allow all guests, including parents, an evening of relaxation we have chosen for our wedding day to be an adult only occasion (with the exception of infants). We hope this advance notice means you are still able to share our big day and will enjoy having the evening off! We are happy to help arrange childcare if needed.</p>
            <p className="question">🤔 What should I wear?</p>
            <p className="answer">Whatever makes you feel great within your definition of “cocktail attire.” Hana said she’s even cool with you wearing white. You should also know the ceremony will be on the roof incase you feel like rocking some sweet shades and sunscreen. And remember, San Francisco stays cool even in May, so remember to bring a layer.</p>
            <p className="question">🤔 What’s the wedding day schedule?</p>
            <p className="answer">We’re asking folks to arrive at 4:30pm sharp. Alex and Hana will then exchange some sweet words and then we’ll get the party started! The reception will end around 11PM, but you better be prepared for the after party.</p>
            <p className="question">🤔 Oh my goodness, you’re having an after party?! Please say there will be karaoke!</p>
            <p className="answer">You bet your sweet ice cream cake there will be an after party with karaoke. If you know us, you know karaoke is the constant force in our relationship. The karaoke after-party is a private event and will happen literally across the street at The Sea Star. It will be KJed by the man, the myth, the legend Maui Mike. Make sure to take a nap before the wedding so you can make it.</p>
            <p className="question">🤔 Do you have a wedding party?</p>
            <p className="answer">Nah, but our siblings have been really helpful during this process. Liana’s our Mermaid of Honor and Grant is the Best Bro.</p>
            <p className="question">🤔 How do I get to the venue?</p>
            <p className="answer">There are many ways to get around San Francisco. A car is very optional, but there is limited street parking at the venue. The K/T Muni Line, which runs from downtown, has a stop very close to the Pearl. You could also use a car service like <a href="https://lyft.com/">Lyft</a>.</p>
          </div>
        </Element>
        <Element className="section no-background row middle-xs center-xs">
          <div className="col-lg-6 col-xs-10">
            <div>Questions? 💌 us at <a href="mailto:us@alexandhana.com">us@alexandhana.com</a>.</div>
          </div>
        </Element>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js